import { render, staticRenderFns } from "./Part7.vue?vue&type=template&id=77927586&scoped=true"
var script = {}
import style0 from "./Part7.vue?vue&type=style&index=0&id=77927586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77927586",
  null
  
)

export default component.exports